import React from 'react';
function Lightbulb({ ...r }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 21" {...r}>
			<path
				fill="#272727"
				d="M5.973 16H7v-5h2v5h1.027c.132-1.202.745-2.194 1.74-3.277.113-.122.832-.867.917-.973a6 6 0 10-9.37-.002c.086.107.807.853.918.974.996 1.084 1.609 2.076 1.741 3.278zM6 18v1h4v-1H6zm-4.246-5a8 8 0 1112.49.002C13.624 13.774 12 15 12 16.5V19a2 2 0 01-2 2H6a2 2 0 01-2-2v-2.5C4 15 2.375 13.774 1.754 13z"
			></path>
		</svg>
	);
}

export default Lightbulb;
